import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b89bca6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "com-contentOne-itemOne-box"
};
const _hoisted_2 = {
  class: "com-contentOne-itemOne-div"
};
const _hoisted_3 = {
  class: "com-contentOne-itemOne-con"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "com-contentOne-itemOne-txt-div"
};
const _hoisted_7 = {
  class: "block-0"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jiahao"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "com-contentOne-itemOne-btn-border"
}, null, -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jiahao"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "com-contentOne-itemOne-btn-border"
}, null, -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
    class: "com-contentOne-itemOne-img",
    width: "100%",
    fit: "cover",
    "icon-size": "0px",
    height: $props.imgHeight
  }, null, 8, ["height"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass(["com-contentOne-itemOne-con-box-slide", {
      'com-contentOne-itemOne-con-box-slide-pre': $data.isPreSlideMose,
      'com-contentOne-itemOne-con-box-slide-next': $data.isNextSlideMose
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["com-contentOne-itemOne-con-bg", {
      'com-contentOne-itemOne-con-bg-mouse': $data.isAddHover,
      'com-contentOne-itemOne-con-bg-reduce-mouse': $data.isReduceHover
    }])
  }, [_createElementVNode("img", {
    class: "com-contentOne-itemOne-con-bg-img",
    alt: "",
    src: Array.isArray($props.slotProps.item.main) && $props.slotProps.item.main.length > 1 ? $props.slotProps.item.main[0] : $props.slotProps.item.main
  }, null, 8, _hoisted_4)], 2), _createElementVNode("div", {
    class: _normalizeClass(["com-contentOne-itemOne-con-bg-color", {
      'com-contentOne-itemOne-con-bg-mouse-bg': $data.isAddHover,
      'com-contentOne-itemOne-con-bg-reduce-mouse-bg': $data.isReduceHover
    }])
  }, [_createElementVNode("img", {
    class: "com-contentOne-itemOne-con-bg-img",
    alt: "",
    src: Array.isArray($props.slotProps.item.main) && $props.slotProps.item.main.length > 1 ? $props.slotProps.item.main[1] : $props.slotProps.item.main
  }, null, 8, _hoisted_5)], 2), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($props.slotProps.item.tagText), 1)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["com-contentOne-itemOne-btns-div", {
      'com-contentOne-itemOne-con-box-slide-pre': $data.isPreSlideMose,
      'com-contentOne-itemOne-con-box-slide-next': $data.isNextSlideMose
    }])
  }, [_createElementVNode("div", {
    class: "com-contentOne-itemOne-btn com-contentOne-itemOne-top-btn",
    onMouseenter: _cache[0] || (_cache[0] = $event => $options.addBtnMoseEnter(1)),
    onMouseleave: _cache[1] || (_cache[1] = $event => $options.addBtnMoseLeave(1)),
    onClick: _cache[2] || (_cache[2] = $event => $options.toChangeSlideFive(1))
  }, _hoisted_10, 32), _createElementVNode("div", {
    class: "com-contentOne-itemOne-btn com-contentOne-itemOne-bottom-btn",
    onMouseenter: _cache[3] || (_cache[3] = $event => $options.addBtnMoseEnter(2)),
    onMouseleave: _cache[4] || (_cache[4] = $event => $options.addBtnMoseLeave(2)),
    onClick: _cache[5] || (_cache[5] = $event => $options.toChangeSlideFive(2))
  }, _hoisted_13, 32)], 2)])])]);
}